// src/App.js
import "./App.css";
import MainContainer from "./containers/MainContainer";
import Layout from "./layouts/MainLayout";
import { DataProvider } from "./contexts/DataProvider";

function App() {
  return (
    <DataProvider>
      <Layout>
        <MainContainer />
      </Layout>
    </DataProvider>
  );
}

export default App;
